import React from 'react';
import { Box } from '@wix/design-system';
import { Logo } from '../Logo';
import { InfoLine } from '../InfoSection';
export const InvoiceHeader = ({ background, businessName, logo, onImageReady, }) => {
    return (React.createElement(Box, { paddingTop: "12px", paddingBottom: "12px", align: "center", direction: "vertical", background: background },
        React.createElement(Logo, { logo: logo, onImageReady: onImageReady }),
        React.createElement(InfoLine, { paddingTop: "8px", weight: "bold" }, businessName)));
};
//# sourceMappingURL=InvoiceHeader.js.map